
import './Home.css';
import ChatInputRedirect from '../../Component/ChatInputRedirect/ChatInputRedirect';

export default function Home() {
  return (
    <div id="home-page" className="home-page component-layout single-center">
      <div className="home-center-wrapper">
        <div className="home-title">Sân bay, Đường dài, Nghỉ dưỡng, Du lịch, Pippip</div>
        <ChatInputRedirect />
      </div>
    </div>
  );
}